import type { ReactNode } from "react";

export const VIEW_ALL_ID = "-2";
export const INDIVIDUAL_ID = "-1";
export const ACTIVE_PROGRAM_ID = "-1";

export interface FilterOption {
  id: string;
  name: ReactNode;
  hasDividerBelow?: boolean;
}

export type ViewMode = "none" | "radio" | "checkbox";
